lmApp
  .service('DVRTaskService', ['$rootScope', '$q', '$http',
    function ($rootScope, $q, $http) {
      var service = {};

      service.GetStream = function(id, token, streamFormat) {
        var deferred = $q.defer();

        var request = {
          headers: {
            'X-Auth-Token': token,
            'X-Instance-Check': ''
          }
        };
        request.url = '/discovery:80/sdp/v2/dvr-tasks/' + id + '/url';
        if (streamFormat) {
            request.url += '?stream_format=' + streamFormat;
        }
        request.method = 'GET';

        $http(request)
            .then(function (response) {
              var answer = response.data;
              deferred.resolve(answer);
            }, function (response) {
              var reason = {};
              reason.url = request.url;
              reason.data = request.data;
              deferred.reject(reason)
            });
        return deferred.promise;
      };

      return service;
    }]);
